/*
 * Copyright (c) 2018 Integral Agile, Inc. All rights reserved.
 *   Use of this file is subject to the terms and conditions defined in the file
 * 'LICENSE.txt'
 *   which is distributed in the root directory of this source code tree.
 */

import Types from '../constants/actionTypes';

const initialState = {
  initialDataLoading: true,
  isFetching: false,
  taskTypes: []
};

const receiveTaskType = (state, taskTypes, taskType) => {
  let newTaskTypes;

  const taskTypeIndex = taskTypes.findIndex(item => item.id === taskType.id);
  if (taskTypeIndex > -1) {
    newTaskTypes = taskTypes.map(item => {
      if (item.id === taskType.id) {
        return taskType;
      }
      return item;
    });
  } else {
    newTaskTypes = taskTypes.concat([taskType]);
  }

  return {
    ...state,
    taskTypes: newTaskTypes,
    isFetching: false,
    initialDataLoading: false
  };
};

const taskTypeReducer = (state = initialState, action) => {
  const { taskTypes, taskType } = action;
  const { taskTypes: allTaskTypes } = state;

  switch (action.type) {
    case Types.REQUEST_TASK_TYPE:
      return { ...state, isFetching: true };
    case Types.RECEIVE_ALL_TASK_TYPES:
      return {
        ...state,
        isFetching: false,
        initialDataLoading: false,
        taskTypes
      };
    case Types.RECEIVE_TASK_TYPE:
      return receiveTaskType(state, allTaskTypes, taskType);
    case Types.CLEAR_ACTIVE_SPINNER:
      return { ...state, isFetching: false, initialDataLoading: false };
    default:
      return state;
  }
};

export default taskTypeReducer;
